module.exports = __webpack_public_path__ + "img/1.81b83604.png";